import React from "react";
import Page from "../../../components/page/Page";
import { Button } from "@vshp/ui-components";
import { useRouter } from "next/router";
import Head from "next/head";
import { ADVANTAGES_IMAGES, ADVANTAGES_INFO } from "../../../constants/advantages";
import PageNotFound from "../../_error";

export async function getStaticPaths() {
  return {
    paths: [
      { params: { id: "1" } },
      { params: { id: "2" } },
      { params: { id: "3" } },
      { params: { id: "4" } },
      { params: { id: "5" } },
      { params: { id: "6" } },
      { params: { id: "7" } },
      { params: { id: "8" } },
      { params: { id: "9" } },
      { params: { id: "10" } },
    ],
    fallback: true,
  };
}

export async function getStaticProps({ params }) {
  const id = params.id;
  const currentId = parseInt(id, 10) - 1;

  return { props: { currentId } };
}

function Advantages({ currentId }) {
  const router = useRouter();

  if (!ADVANTAGES_INFO[currentId]) {
    return <PageNotFound />;
  }

  const title = ADVANTAGES_INFO[currentId].title;

  const backBtn = (
    <Button onClick={() => router.replace("/")} maxWidth={true}>
      Вернуться назад
    </Button>
  );

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <Page title={title} isExtraBlock={true} extraContent={backBtn} coverImg={ADVANTAGES_IMAGES[currentId]} isWidthSmall={true}>

          <div className="page__block" dangerouslySetInnerHTML={{ __html: ADVANTAGES_INFO[currentId].content }}></div>

      </Page>
    </>
  );
}

export default Advantages;
